<template>
    <span>

        <div v-if="searchString == ''" class="ItemSearchPartsTree">

            <li>
                <div class="treeline">
                    <div class="expand__container">
                        <img class="expandimage"
                            v-if="isFolder !== undefined && open == false && model.children.length > 0" @click="toggle"
                            src="/static/branch-collapsed.png">


                        <img class="expandimage"
                            v-if="isFolder !== undefined && open == true && model.children.length > 0" @click="toggle"
                            src="/static/branch-expanded-dark.png">


                        <img class="expandimage" v-if="!isFolder" src="/static/transparent_icon_24.png">
                    </div>

                    <span v-if="model.type === folder" :class="folder"></span>
                    <span v-if="model.type !== folder" class="nofolder"></span>

                    <a v-if="model.type === folder" class="category__name" v-bind:class="{ active: classObject }"
                        @click="select">{{model.name}}</a>
                    <a v-if="model.type !== folder" class="category__name" v-bind:class="{ active: isActive }"
                        @click="select">{{model.name}}</a>

                    <div class="deletebutton">
                        <button v-show="showDelete" v-b-tooltip.hover.left size="sm" type="submit"
                            class=" my-2 my-sm-0 deleteButton" v-if="edit" :id="'id_'+model.categoryId"
                            @click="onClickDelete(model.id)">{{lang.button_Delete}}</button>
                    </div>
                </div>

                <ul v-show="open" v-if="isFolder" class="library_ul">
                    <ItemSearchPartsTree :action="action" :searchString="searchString" class="library_item" :lang="lang"
                        v-for="model in model.children" :model="model" :edit="edit" :key="model.categoryId"></ItemSearchPartsTree>
                </ul>




            </li>
        </div>
        <span v-if="searchString != ''" class="ItemSearchPartsTree">
            <span v-if="searchStringExist">
                <li>
                    <div class="treeline">
                        <span v-if="searchStringExist">

                            <span v-if="model.type === folder" :class="folder"></span>
                            <span v-if="model.type !== folder" class="nofolder"></span>

                            <a v-if="model.type === folder" class="category__name"
                                v-bind:class="{ active: classObject }" @click="select">{{model.name}}</a>
                            <a v-if="model.type !== folder" class="category__name" v-bind:class="{ active: isActive }"
                                @click="select">{{model.name}}</a>

                            <div class="deletebutton">
                                <button v-show="showDelete" v-b-tooltip.hover.left size="sm" type="submit"
                                    class=" my-2 my-sm-0 deleteButton" v-if="edit" :id="'id_'+model.categoryId"
                                    @click="onClickDelete(model.id)">{{lang.button_Delete}}</button>
                            </div>
                        </span>
                    </div>

                </li>

            </span>
            <span v-show="open" v-if="isFolder" class="library_ul_flat">

                <ItemSearchPartsTree :action="action" :searchString="searchString" class="library_item" :lang="lang"
                    v-for="model in model.children" :model="model" :edit="edit" :key="model.categoryId"></ItemSearchPartsTree>
            </span>
        </span>
    </span>
</template>

<script>



export default {
    name: 'ItemSearchPartsTree',
    props: {
        model: Object,
        edit: Boolean,
        lang: Object,
        searchString: String,
        action: Boolean,

    },
    data: function () {
        return {
            open: true,
            folder: "folder",
            showDelete: false,
            categoryName: "",
            deleteButtonName: "delete-" + this.model.name,
            objAlertSuccess: {
                text: this.lang.alert_success_delete_category,
                type: "success", //success, danger, warning, info
                time: 5 //sec.

            },
            objAlertError: {
                text: this.lang.alert_error_delete_category,
                type: "danger", //success, danger, warning, info
                time: 5 //sec.
            },
            searchStringExist: false,

        };
    },
    computed: {

        isFolder: function () {

            if (this.model.children == undefined) {
                return

            }
            return this.model.children.length > 0;
        },
        isActive() {

            return this.$store.getters.selectedSearchPartsTreeItemObject.categoryId == this.model.categoryId;
        },
        uid() {

            return this._uid
        },
        classObject() {
            return {
                active: this.isActive
            }
        }


    },
    mounted() {

    },
    updated() {

    },
    watch: {
        searchString: function (newVal, oldVal) {

            let name = this.model.name.toLowerCase();

            let index = name.indexOf(newVal.toLowerCase());

            if (index > -1) {
                this.searchStringExist = true;

            } else {
                this.searchStringExist = false;

            }


        }
    },
    methods: {
        toggle: function () {

            if (this.isFolder) {
                this.open = !this.open;
            }

        },
        onClickDelete: function (id) {

            if (this.model.categoryId == 1) {
                return
            }

            let action = "_checkIfPartsInCategory";
            if (this.$store.getters.sectionPrefix == "lm") {
                action = "_checkIfLibrariesInCategory";
            }

            let vue = this;
            this.$store.dispatch(this.$store.getters.sectionPrefix + action, { categoryId: this.model.categoryId })
                .then(function (result) {

                    if (result.data > 0) {
                        vue.deleteWithParts(result.data);
                    } else {
                        vue.delete();

                    }

                })

        },
        delete: function () {

            let deleteFunc = async () => {
                await this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteCategory", { "categoryId": this.model.categoryId, objAlertSuccess: this.objAlertSuccess, objAlertError: this.objAlertError });
                this.$store.dispatch("reloadAfterDeleteTreeItem", true)

            }


            let obj = {
                title: this.lang.alerttitle_Delete,
                text: this.lang.alertinfo_1,
                type: "sure",
                buttons: 2,
                size: "sm",
                funcNo: "",
                funcYes: deleteFunc
            };
            this.$store.dispatch("showAlert", obj);
        },
        deleteWithParts: function (qty) {
            

            let deleteFunc = async () => {
                await this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteCategory", { "categoryId": this.model.categoryId, objAlertSuccess: this.objAlertSuccess, objAlertError: this.objAlertError });
                this.$store.dispatch("reloadAfterDeleteTreeItem", true)

            }
            let str = "";
            let alerttext = "";
            if (this.$store.getters.sectionPrefix == "lm") {
                str = qty + " libraries";
                if (qty == 1) {
                    str = qty + " library";
                }
                alerttext = this.lang.alertinfo_4;

            }
            if (this.$store.getters.sectionPrefix == "pm") {
                str = qty + " parts";
                if (qty == 1) {
                    str = qty + " part";
                }
                alerttext = this.lang.alertinfo_3;
            }



            let obj = {
                title: this.lang.alerttitle_Delete,
                text: this.lang.alertinfo_2 + str + ". " + alerttext,
                type: "sure",
                buttons: 2,
                size: "sm",
                funcNo: "",
                funcYes: deleteFunc
            };

            this.$store.dispatch("showAlert", obj);
        },
        select: function () {


            this.categoryName = this.model.categoryId === 1 ? "" : this.model.name;
            let buttons = document.querySelectorAll(".deleteButton");

            for (let button of buttons) {
                let id = "id_" + this.model.categoryId;
                if (button.id === id && button.id !== 1) {
                    button.style.display = "block";


                }
                if (id !== button.id) {
                    button.style.display = "none";

                }

            }



            this.$store.dispatch('selectSearchPartsTreeItem', this._uid);

            this.$store.dispatch('selectSearchPartsTreeItemObject', this.model);

            if (this.action == true) {

                this.$store.dispatch('setSearchPartsElementCategory', this.model.category);

            }

        },
        changeType: function () {
            if (!this.isFolder) {
                Vue.set(this.model, 'children', []);
                this.addChild();
                this.open = true;
            }
        }

    }
}
</script>


<style lang="scss">
.ItemSearchPartsTree {
    .expandimage {
        width: 16px;
        height: 16px;
        margin-left: 5px;
    }

    .expand__container {
        width: 20px;
        height: 15px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-direction: column;
    }

    .library_item {
        cursor: pointer;

    }

    .library_ul {
        padding-left: 18px;
        line-height: 1.1em;
        list-style-type: none;

    }

    .library_ul_flat {
        padding-left: 0px;
        line-height: 1.5em;
        list-style-type: none;

    }

    .deleteButton {
        margin-left: 5px;
        border-radius: 3px;
        border: 1px solid white;
    }

    .category__name {
        cursor: pointer;
        font-size: 0.75rem;
    }

    .folder {
        background-image: url("/static/folder.svg");
        width: 19px;
        height: 16px;
        display: block;
        margin-right: 10px;
    }

    .nofolder {
        background-image: url("/static/folder.svg");
        width: 19px;
        height: 16px;
        display: block;
        margin-right: 10px;
        float: left;
    }

    .treeline {
        display: inline-flex;

    }

    a {
        padding-right: 10px;
        padding-left: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/ItemSearchPartsTree.vue